import React from 'react';
import { getConfigs, getOverlayers } from '@starflow/app/extension';
import { overLayerControlsHideThreshold } from '@shakkerai/pro-constants';
import { useTempState, useViewport, useProjectState } from '@starflow/app/store';
import { OverlayerWrapper } from './Wrapper';
import { ImageOverlayer } from './image';
import { GroupOverlayer } from './group';

export const coreOverlayers = {
  image: ImageOverlayer,
  group: GroupOverlayer,
};

export const Overlayers = React.memo(() => {
  const viewport = useViewport();
  const extensionOverlayers = getOverlayers();
  const elements = useProjectState('elements');
  const selecting = useTempState('selecting');
  const selection = useProjectState('selection');
  const currentTask = useProjectState(({ tasks }) => tasks.map[tasks.current]);
  const currentTaskElementId = currentTask ? currentTask.params.sourceElement?.id : null;

  const currentElementTool = useProjectState('currentElementTool');
  const editingElementId = useProjectState('editingElementId');
  const hoveringElementId = useTempState('hoveringElementId');

  const isMultiSelect = selection.length > 1;
  const exactlySelectedElementId = !isMultiSelect ? selection[0] : null;

  if (isMultiSelect || selecting) return null;

  return (
    <div
      id="overlayers"
      data-proxy-wheel="true"
      className="starflow-canvas-overlayers absolute inset-0 pointer-events-none z-[0]"
    >
      {elements.map((element) => {
        const Overlayer = extensionOverlayers[element.type] || coreOverlayers[element.type];

        if (!Overlayer) return null;

        const config = getConfigs()[element.type];
        const isEditing = editingElementId === element.id;
        const isHovering = hoveringElementId === element.id;
        const isExactlySelected = exactlySelectedElementId === element.id;
        const isTaskRunning = currentTaskElementId === element.id;

        const elementRenderedWidth = element.width * element.scaleX * viewport.scale;
        const isMiniMode = elementRenderedWidth < overLayerControlsHideThreshold;

        if (
          !isHovering &&
          !isEditing &&
          !isExactlySelected &&
          !config?.unselectable &&
          !isTaskRunning &&
          !element.topTitle
        )
          return null;

        return (
          <OverlayerWrapper key={element.id} element={element} viewport={viewport} isMiniMode={isMiniMode}>
            <Overlayer
              element={element}
              viewport={viewport}
              selection={selection}
              isHovering={isHovering}
              isEditing={isEditing}
              isMiniMode={isMiniMode}
              isTaskRunning={isTaskRunning}
              taskData={isTaskRunning ? currentTask : null}
              isExactlySelected={isExactlySelected}
              currentElementTool={currentElementTool}
              editingElementId={editingElementId}
            />
          </OverlayerWrapper>
        );
      })}
    </div>
  );
});
// export const Overlayers = () => {
//   const dragging = useTempState('dragging');
//   const spacePressing = useTempState('spacePressing');
//   const canvasAction = useTempState('canvasAction');
//   const selectionRect = useTempState('selectionRect');
//   const taskQueue = useProjectState('taskQueue');

//   const isSelecting = !!selectionRect;
//   const canvasInteracting =
//     spacePressing || dragging || isSelecting || canvasAction === 'move' || Shapes.has(canvasAction);

//   useEffect(() => {
//     if (canvasInteracting) {
//       document.body.classList.add('canvas-interacting');
//     } else {
//       document.body.classList.remove('canvas-interacting');
//     }

//     return () => {
//       document.body.classList.remove('canvas-interacting');
//     };
//   }, [canvasInteracting]);

//   return (
//     <>
//       <TaskOverLayers canvasInteracting={canvasInteracting} />
//       <TaskQueueOverlayers taskQueue={taskQueue} />
//       <ImageOverLayers />
//     </>
//   );
// };
